






































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { CORRECT_CONSERVATEE_BIRTHDAY } from '../../../store/actions';
import { ConservatorshipDetails, CorrectBirthday } from '../../../types';
import { ApiResponse } from '@/components/types';
import DatePicker from '@/components/form/DatePicker.vue';

const Conservatorship = namespace('conservatorship');

@Component({
  components: {
    DatePicker
  }
})
export default class BirthdayCorrectDialog extends Vue {
  @Prop({ type: Object, required: true }) conservatorship!: ConservatorshipDetails;
  @Conservatorship.Action(CORRECT_CONSERVATEE_BIRTHDAY) correctBirthday!: (params: CorrectBirthday) => Promise<ApiResponse>;

  dialog: boolean = false;
  error: any = null;

  value: CorrectBirthday = {
    conservatee_id: this.conservatorship.id,
    birthday: this.conservatorship.conservatee.birthday,
  };

  @Watch('dialog')
  watchDialogClosed(dialog: boolean) {
    if (dialog) {
      this.value = {
        conservatee_id: this.conservatorship.id,
        birthday: this.conservatorship.conservatee.birthday,
      };

      return;
    }

    setTimeout(() => {
      // @ts-ignore
      this.$refs.form.reset();
      this.error = null;
    }, 200);
  }

  async save() {
    this.error = null;

    return this.correctBirthday(this.value);
  }
}
